import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=f485ea8c&scoped=true"
import script from "./Directory.vue?vue&type=script&lang=js"
export * from "./Directory.vue?vue&type=script&lang=js"
import style0 from "./Directory.vue?vue&type=style&index=0&id=f485ea8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f485ea8c",
  null
  
)

export default component.exports